import { useTranslation } from "react-i18next";

import BaseModal from "@/components_v2/Modal/BaseModal";
import BaseButton from "@/components_v2/Button/BaseButton";
import useEditDataBlockRequestForm from "@/features/evidence-requests/hooks/useEditDataBlockRequestForm";
import EditRequestForm from "@/domains/evidence-requests/components/EditRequestForm";
import { EditRequestModalProps } from "@/domains/evidence-requests/types";

import "../styles.css";

const EditRequestModal = ({
  open,
  setOpen,
  request,
}: EditRequestModalProps) => {
  const { t } = useTranslation();

  const formHook = useEditDataBlockRequestForm({
    request,
    onSuccess: () => {
      setOpen(false);
    },
  });

  return (
    <BaseModal
      title={t("datablocks.labels.editRequest")}
      open={open}
      onCancel={() => setOpen(false)}
      width={800}
      footer={
        <div className="edit-request-modal-footer">
          <BaseButton onClick={formHook.handleSubmit}>
            {t("datablocks.labels.send")}
          </BaseButton>
        </div>
      }
    >
      <EditRequestForm formHook={formHook} />
    </BaseModal>
  );
};

export default EditRequestModal;
